<template>
  <div class="my-account-order-entry-article-list">
    <div class="text-xl font-bold py-4">Bestellte Artikel</div>
    <div class="lg:grid lg:grid-cols-12 gap-8 font-bold hidden">
      <div class="col-span-2">Artikel</div>
      <div class="col-span-4 invisible">Artikelname</div>
      <div class="col-span-2">Artikelnummer</div>
      <div class="col-span-2 text-right">Einzelpreis</div>
      <div class="col-span-1 text-right">Anzahl</div>
      <div class="text-right">Gesamt</div>
    </div>
    <div class="flex flex-col gap-12 py-4 relative">
      <div v-for="bin in order.shippingBins.bins" :key="bin.itemList.id">
        <MyAccountOrderEntryArticleEntry v-for="(item, index) in bin.itemList.items" :key="index" :item="item" />
      </div>
      <div class="my-4 font-bold grow">
        <NuxtLink class="lg:absolute lg:bottom-0 lg:right-0 w-full lg:w-auto btn-primary inline-block text-center px-8 py-4" :to="'/shop/mein-expert/retoure?orderId=' + order.id">Retoure anmelden</NuxtLink>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { Order } from '~/composables/shoppingCartApi';
defineProps({
  order: {
    type: Object as PropType<Order>,
    required: true
  }
});
</script>